import { computed } from '@vue/composition-api';
import { useTheme } from './useTheme.js';
import { getAssetsDomain } from '../assets/assetsDomain.js';

function useThemedLogo(logoName) {
    var theme = useTheme().theme;
    return computed(function () {
        var path = "".concat(logoName.value, "-").concat(theme.value, ".svg");
        return "".concat(getAssetsDomain(), "/app-assets/sds-logos/").concat(path);
    });
}

export { useThemedLogo };
